import {
  PATH_SCENARIO_CHANNEL,
  PATH_SCENARIO_SEARCH,
  PATH_SCENARIO_RESULTS,
  PATH_SCENARIO_SUMMARY,
} from '../../../../route/constants';

export const SCENARIO_STEPS = [
  { label: 'Select Channel', path: PATH_SCENARIO_CHANNEL },
  { label: 'Search', path: PATH_SCENARIO_SEARCH },
  { label: 'Results', path: PATH_SCENARIO_RESULTS },
  { label: 'Rate Summary', path: PATH_SCENARIO_SUMMARY },
];

export const PAGE_TITLE = 'New Scenario';

export interface ChannelOption {
  id: (typeof DEFAULT_CHANNEL_IDS)[number];
  label: keyof typeof KNOWN_CHANNEL_LABELS;
  value: (typeof CHANNEL_TO_LOAN_CHANNEL)[keyof typeof CHANNEL_TO_LOAN_CHANNEL];
  wsChannel?: string;
}

export const KNOWN_CHANNEL_LABELS: Record<string, string> = {
  // TPOC treats Broker as Wholesale
  Broker: 'Wholesale',
  NonDelegated: 'Correspondent Non-Delegated',
  Delegated: 'Correspondent Delegated',
};

// Wholesale Channel only
export const WHOLESALE_CHANNEL_TYPES: Record<string, string> = {
  Delegated: 'CorrespondentDelegated',
  NonDelegated: 'CorrespondentNonDelegated',
};

// Default channel IDs used as a fallback when SSF returns
// no channel types (e.g., during local development or
// if the TPOAdminSettings are not configured).
export const DEFAULT_CHANNEL_IDS = [
  'Broker',
  'Correspondent',
  'NonDelegated',
] as const;

// Maps SSF channel type to EPPS loanChannel number.
export const CHANNEL_TO_LOAN_CHANNEL = {
  // TPOC Treats broker as wholesale
  Broker: 2,
  Delegated: 4, // Correspondent Delegated
  NonDelegated: 4, // Correspondent Non-Delegated
} as const;
